import { OrderedMap } from 'immutable';
import parseJSON from 'date-fns/parseJSON';

export const parseBrowserName = (browser) => (typeof browser === 'string' ?
  browser.replace(/(.*)\s(\S*[0-9]\S*$)/, '$1') :
  browser);

export const parseTest = (test, users) => ({
  ...test,
  ...(test.os_normalized ? { os: test.os_normalized } : null),
  creation_time: parseJSON(test.creation_time),
  modification_time: parseJSON(test.modification_time),
  owner: users.get(test.user_id)?.username || '',
  browser: parseBrowserName(test.browser),
});

export const parseUsers = (users) => (
  OrderedMap().withMutations((map) => (
    users.reduce((output, user) => (
      output.set(user.id, user)
    ), map)
  ))
);
